module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_cuadrada_marco_comida_26.131d79a3.png";